import { Platform } from 'react-native'
import Rollbar from 'rollbar'

export const RollbarErrorTracking = (() => {
  if (
    process.env.EXPO_PUBLIC_ROLLBAR_POST_CLIENT_ITEM === undefined ||
    process.env.EXPO_PUBLIC_ROLLBAR_POST_CLIENT_ITEM.length === 0
  ) {
    console.warn('Rollbar token missing')

    return {
      error: () => {},
    }
  }

  const RollbarObj = new Rollbar({
    enabled: process.env.BABEL_ENV !== 'development' && process.env.NODE_ENV !== 'development',
    environment: process.env.EXPO_PUBLIC_APP_ENV || 'development',
    accessToken: process.env.EXPO_PUBLIC_ROLLBAR_POST_CLIENT_ITEM,
    captureIp: 'anonymize',
    captureUncaught: true,
    captureUnhandledRejections: true,
    payload: {
      os: Platform.OS,
    },
  })

  const error = (obj: Rollbar.LogArgument) => {
    RollbarObj.error(obj)
  }

  const configure = (options: Rollbar.Configuration) => {
    RollbarObj.configure(options)
  }

  return { error, configure }
})()

export default RollbarErrorTracking
